import { render, staticRenderFns } from "./CharacterInfo.vue?vue&type=template&id=5c68f1f8&"
import script from "./CharacterInfo.vue?vue&type=script&lang=js&"
export * from "./CharacterInfo.vue?vue&type=script&lang=js&"
import style0 from "./CharacterInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/tty215/Develop/mmmcom/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VListTile,VListTileAvatar,VTextField})
